export default {
  resource: "admin.adminPlugins.show",
  path: "/plugins",

  map() {
    this.route("community-navigation-structure", { path: "structure" });
  },
};
